module.exports = __webpack_public_path__ + "098416fd71f525c6a1f66630b079f044.jpg";